import Table from 'react-bootstrap/Table';
import SortableItem from './SortableItem';
import {Button, Stack} from "react-bootstrap";
import useTranslation from "../hooks/translations";
import {FontAwesomeIcon} from "@fortawesome/react-fontawesome";
import {
  DndContext,
  KeyboardSensor,
  MouseSensor,
  TouchSensor,
  useSensor,
  useSensors
} from '@dnd-kit/core';
import {
  restrictToVerticalAxis,
  restrictToWindowEdges
} from '@dnd-kit/modifiers';
import {
  arrayMove,
  SortableContext,
  sortableKeyboardCoordinates,
  verticalListSortingStrategy,
} from '@dnd-kit/sortable';

export default function SortableDataTable({
                                            title,
                                            columns,
                                            rows,
                                            editAction,
                                            deleteAction,
                                            addAction,
                                            dragEndAction
                                          }) {
  const translations = useTranslation();

  const sensors = useSensors(
    useSensor(TouchSensor),
    useSensor(MouseSensor),
    useSensor(KeyboardSensor, {
      coordinateGetter: sortableKeyboardCoordinates
    })
  );

  const handleDragEnd = async (event) => {
    const {active, over} = event;

    if (active.id !== over.id) {
      const oldIndex = rows.map((el) => el.id).indexOf(active.id);
      const newIndex = rows.map((el) => el.id).indexOf(over.id);

      let data = arrayMove(rows, oldIndex, newIndex);
      if (dragEndAction) {
        dragEndAction(data)
      }
    }
  }

  return (
    <div className="container-xl px-4 mt-n10">
      <div className="card mb-4">
        <div className="card-header">
          <Stack direction="horizontal">
            <div className="p-2">{title}</div>
            {addAction &&
              <div className="p-2 ms-auto">
                <Button variant="primary"
                        onClick={() => {
                          addAction();
                        }
                        }>
                  <FontAwesomeIcon icon="add" className="me-2"/>
                  {translations.add}
                </Button>
              </div>
            }
          </Stack>
        </div>
        <DndContext
          sensors={sensors}
          onDragEnd={handleDragEnd}
          modifiers={[restrictToVerticalAxis, restrictToWindowEdges]}
        >
          <div className="card-body">
            <div
              className="datatable-wrapper">
              <div className="datatable-container">
                <SortableContext
                  items={rows}
                  strategy={verticalListSortingStrategy}
                >
                  <Table responsive bordered striped>
                    <thead>
                    <tr>
                      {
                        columns.map((column, index) => (
                            <th key={index}>{column.name}</th>
                          )
                        )
                      }
                      {
                        (editAction || deleteAction) &&
                        <th>{translations.actions}</th>
                      }
                    </tr>
                    </thead>
                    <tbody>
                    {
                      rows.map((row, _) => (
                          <SortableItem key={row.id}
                                        row={row}
                                        columns={columns}
                                        editAction={editAction}
                                        deleteAction={deleteAction}/>

                        )
                      )
                    }
                    </tbody>
                  </Table>
                </SortableContext>
              </div>
            </div>
          </div>
        </DndContext>
      </div>
    </div>
  )
}
